import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { EuiSpacer } from "@elastic/eui";
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/AlarmPerm';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Features/Email/SuccessBox';
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
export const _frontmatter = {
  "title": "Features Menü // Alarm Emails",
  "path": "/Web_User_Interface/1440p_Serie/Features/Email_Einstellungen/",
  "dateChanged": "2021-12-12",
  "author": "Mike Polinowski",
  "excerpt": "Im Email Menü können Sie die Absender und Ihre Empfänger Adresse für die Email Benachrichtigung hinterlegen. Der Absender muss entsprechend des gewählten SMTP Accounts gesetzt werden. Beachten Sie bitte, dass einige Email Anbieter es nicht erlauben, wenn Absender und Empfänger Email gleich gewählt werden! Als Empfänger können Sie mehrere Email Adressen über die entsprechenden Eingabefelder eingegeben werden. Es ist empfohlen auch einen Betreff und Email Text (max. 64 Zeichen) einzutragen, da leere Emails ggf. an Spam-Wächtern hängen bleiben.",
  "image": "./WebUI_1440p_SearchThumb_Features_Email.png",
  "social": "/images/Search/WebUI_1440p_SearchThumb_Features_Email.webp",
  "toc": "/images/Search/TOC_Icons/Wiki_Tiles_WebUI_white.webp",
  "chapter": "1440p Web User Interface"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <SEOHelmet title="Features Menü // Alarm Emails" dateChanged="2021-12-12" author="Mike Polinowski" tag="INSTAR IP Camera" description="Im Email Menü können Sie die Absender und Ihre Empfänger Adresse für die Email Benachrichtigung hinterlegen. Der Absender muss entsprechend des gewählten SMTP Accounts gesetzt werden. Beachten Sie bitte, dass einige Email Anbieter es nicht erlauben, wenn Absender und Empfänger Email gleich gewählt werden! Als Empfänger können Sie mehrere Email Adressen über die entsprechenden Eingabefelder eingegeben werden. Es ist empfohlen auch einen Betreff und Email Text (max. 64 Zeichen) einzutragen, da leere Emails ggf. an Spam-Wächtern hängen bleiben." image="/images/Search/WebUI_1440p_SearchThumb_Features_Email.png" twitter="/images/Search/WebUI_1440p_SearchThumb_Features_Email.webp" location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN="/en/Web_User_Interface/1440p_Series/Features/Email/" locationFR="/fr/Web_User_Interface/1440p_Series/Features/Email/" crumbLabel="Alarm Emails" mdxType="BreadCrumbs" />
    <h1 {...{
      "id": "ultrahd-serien-2k-1440p--4k-2160p",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#ultrahd-serien-2k-1440p--4k-2160p",
        "aria-label": "ultrahd serien 2k 1440p  4k 2160p permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`UltraHD Serien (2K+ 1440p & 4K 2160p)`}</h1>
    <h2 {...{
      "id": "features-menü",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#features-men%C3%BC",
        "aria-label": "features menü permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Features Menü`}</h2>
    <EuiSpacer mdxType="EuiSpacer" />
    <SuccessBox mdxType="SuccessBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <PermissionBox mdxType="PermissionBox" />
    <EuiSpacer mdxType="EuiSpacer" />
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/192cc8dcf28f512765fa27fb7ab0d0b6/f53a0/1440p_Settings_Features_Email_Settings.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "51.30434782608696%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACN0lEQVQoz2WSy04TARSGeRA2RJnSi02KlpnptDOddjqd0ullLm1lrBoLWAwSE5C7kehCjOALsGFh3BIDrtREFj6BvoOv8ZkZKF24+HNOcpIv//nzT6TTaVKpFKnUHWaE2zRXj+ke/qT1+oL2wVesvfNItf2Lm91+dc7D40uUzjq6mmMmHmdycpKpqSkmEokEV0oiCNOYTp/ucAd3sE736TYLz/ai6S9t0hvu0FnaxF98SW+4S7UVoKklZFnl7qxIJnOPiWQyGQHDKQgxjJJGx23ituo87t9n+ckjHgVdvJaN17ZpzlexayZNu0rDrNO2B1iVJmXdQMmpVw5HUEEQqJgmQfCATreL3+niuh6O6+I4LoZRQSvqFAoqhWKRvrPAhj+g05ynYujIUp6JeDweAcMZAk3TpN/v43kejuPgum6kcNd1nVwuhyRJyEqewG3y8UWHlUEZyywiidfAUY6Rw0qFIAjwff8/YHgLoZqmoSgKa2vPOft0xHKgUioWUfPK2GGoWCx24zAEjkBjhyUKhQKyJDGbyXD4/pC/vy45WumjaXn0wjUwrM3IYZhTmJ3jjYGR2i3q8zUsy8K0LLRymTd7O/z58Y3TrTVsQyUnK+OXk8kEt6ZjeHWDs4MWn3dtFgMXx+vge216q2/p7Z8yXNzipNHiXa3Bh60Nfn//wsn2Eis9A0nOj3sYgsOXJTFLoyxhaVkUWUQUJURRRMrriFo1qoaZzVKeE8nNZdHELGI6STo5E/X4HyVUd+eo9ukgAAAAAElFTkSuQmCC')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/192cc8dcf28f512765fa27fb7ab0d0b6/e4706/1440p_Settings_Features_Email_Settings.avif 230w", "/de/static/192cc8dcf28f512765fa27fb7ab0d0b6/d1af7/1440p_Settings_Features_Email_Settings.avif 460w", "/de/static/192cc8dcf28f512765fa27fb7ab0d0b6/7f308/1440p_Settings_Features_Email_Settings.avif 920w", "/de/static/192cc8dcf28f512765fa27fb7ab0d0b6/23a38/1440p_Settings_Features_Email_Settings.avif 1062w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/192cc8dcf28f512765fa27fb7ab0d0b6/a0b58/1440p_Settings_Features_Email_Settings.webp 230w", "/de/static/192cc8dcf28f512765fa27fb7ab0d0b6/bc10c/1440p_Settings_Features_Email_Settings.webp 460w", "/de/static/192cc8dcf28f512765fa27fb7ab0d0b6/966d8/1440p_Settings_Features_Email_Settings.webp 920w", "/de/static/192cc8dcf28f512765fa27fb7ab0d0b6/dac18/1440p_Settings_Features_Email_Settings.webp 1062w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/192cc8dcf28f512765fa27fb7ab0d0b6/81c8e/1440p_Settings_Features_Email_Settings.png 230w", "/de/static/192cc8dcf28f512765fa27fb7ab0d0b6/08a84/1440p_Settings_Features_Email_Settings.png 460w", "/de/static/192cc8dcf28f512765fa27fb7ab0d0b6/c0255/1440p_Settings_Features_Email_Settings.png 920w", "/de/static/192cc8dcf28f512765fa27fb7ab0d0b6/f53a0/1440p_Settings_Features_Email_Settings.png 1062w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/192cc8dcf28f512765fa27fb7ab0d0b6/c0255/1440p_Settings_Features_Email_Settings.png",
              "alt": "Web User Interface - 1440p Series - Features Email",
              "title": "Web User Interface - 1440p Series - Features Email",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <h3 {...{
      "id": "geben-sie-empfänger-adressen-für-die-e-mails-ein",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#geben-sie-empf%C3%A4nger-adressen-f%C3%BCr-die-e-mails-ein",
        "aria-label": "geben sie empfänger adressen für die e mails ein permalink",
        "className": "header-link-icon before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Geben Sie Empfänger Adressen für die E-Mails ein`}</h3>
    <p>{`Um Ihnen von der Kameras Emails schicken zu lassen, müssen Sie zunächst die SMTP Einstellungen vonehmen. Wir empfehlen die INSTAR SMTP Server Voreinstellungen. Wenn der INSTAR SMTP Server ausgewählt ist, geben Sie nur Ihre Empfänger Adresse an (unten) und bestätigen und testen Sie Ihre Einstellungen.`}</p>
    <p><span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "920px"
        }
      }}>{`
      `}<a parentName="span" {...{
          "className": "gatsby-resp-image-link",
          "href": "/de/static/ed52097d7c6355d3793a505f7e3cb29d/2e367/1440p_Settings_Features_Email_Receiver.png",
          "style": {
            "display": "block"
          },
          "target": "_blank",
          "rel": "noopener"
        }}>{`
    `}<span parentName="a" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "55.65217391304348%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAALCAYAAAB/Ca1DAAAACXBIWXMAAA7rAAAO6wFxzYGVAAACcUlEQVQoz2WSS2sTURhA8ytE6yNVm9Q0aRvN00kmk2RmMunMNM28ksakVVGUWvEd0VKlvmgVd27EXemureBSXSgI4kIQXfh7jsxErcXF4btw4XDuIzQxMUEikSAxPs7oyGG0s/dxH73DuLOFufSa2u0t1P4A5dYmSn+L+u1NOqvvEdwbSMU8x2IxhoaGGB4OExobG8MnHo8TGTmCap+hc3UNd2GF1uIj2pcf4y0+DNanrq7iXXoY7J26tkbdPYeQF8hk8iSTKZLJE4R80R8i0SiVUgGnMUXT0HAaOp5l4jYN5jou58906XhNZowa1rSGUdNQpWmazTkqkkpBkHYKfSKRCFVZptubw/NaWLaDZdvBtG0HWVGoVGWkcgWxJOHoLvPaaTrGHHVVoSSKhGKxWFD3V1it0u128TwPx3GwLCvAtm10Xac+Vceo6+hdHctrcrfd4smCS6slIxaKA+Guwt/Cdrsd4LpuIPOlqqoiiiLFYpFSVcI0VZb7F3j+YB67IVAsiDtCvzIajQbCXq8XFPq0Wq2g1KfRaGAYBqZpoioq/ZvX+fH1Mx9ePWPWkBCEwkDofxtf6gslSaIgCKTTaVKp1C4ymUxALpdlcjLJyvIdfn75xLeNDW7OzpA/efL/wnK5TE2rB5evKMo/yChydTBVlaIksXT9Ct/fvuHj5jpPL1posrj7lY+ORDC1KtsrNtv3GyzMu9jeLG3PobP4gM69dS5eWOKlOcOLpoujG2iVEjUhi3A8znj82M4/DI48Oko2k8Ko5tFKaYR8lmw2Ry6bJVeQyJVUBKGEnE6j5vIk4nH27N3H/gMHOXAwzKFwmF/hSpkXIScTXAAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/ed52097d7c6355d3793a505f7e3cb29d/e4706/1440p_Settings_Features_Email_Receiver.avif 230w", "/de/static/ed52097d7c6355d3793a505f7e3cb29d/d1af7/1440p_Settings_Features_Email_Receiver.avif 460w", "/de/static/ed52097d7c6355d3793a505f7e3cb29d/7f308/1440p_Settings_Features_Email_Receiver.avif 920w", "/de/static/ed52097d7c6355d3793a505f7e3cb29d/730d0/1440p_Settings_Features_Email_Receiver.avif 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/avif"
            }}></source><source parentName="picture" {...{
              "srcSet": ["/de/static/ed52097d7c6355d3793a505f7e3cb29d/a0b58/1440p_Settings_Features_Email_Receiver.webp 230w", "/de/static/ed52097d7c6355d3793a505f7e3cb29d/bc10c/1440p_Settings_Features_Email_Receiver.webp 460w", "/de/static/ed52097d7c6355d3793a505f7e3cb29d/966d8/1440p_Settings_Features_Email_Receiver.webp 920w", "/de/static/ed52097d7c6355d3793a505f7e3cb29d/fbb05/1440p_Settings_Features_Email_Receiver.webp 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/webp"
            }}></source>{`
          `}<source parentName="picture" {...{
              "srcSet": ["/de/static/ed52097d7c6355d3793a505f7e3cb29d/81c8e/1440p_Settings_Features_Email_Receiver.png 230w", "/de/static/ed52097d7c6355d3793a505f7e3cb29d/08a84/1440p_Settings_Features_Email_Receiver.png 460w", "/de/static/ed52097d7c6355d3793a505f7e3cb29d/c0255/1440p_Settings_Features_Email_Receiver.png 920w", "/de/static/ed52097d7c6355d3793a505f7e3cb29d/2e367/1440p_Settings_Features_Email_Receiver.png 1066w"],
              "sizes": "(max-width: 920px) 100vw, 920px",
              "type": "image/png"
            }}></source>{`
          `}<img parentName="picture" {...{
              "className": "gatsby-resp-image-image",
              "src": "/de/static/ed52097d7c6355d3793a505f7e3cb29d/c0255/1440p_Settings_Features_Email_Receiver.png",
              "alt": "Web User Interface - 1440p Series - Features Email",
              "title": "Web User Interface - 1440p Series - Features Email",
              "loading": "lazy",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              }
            }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span></p>
    <p>{`Im Email Menü können Sie die Absender und Ihre Empfänger Adresse für die Email Benachrichtigung hinterlegen. Der Absender muss entsprechend des gewählten SMTP Accounts gesetzt werden. Beachten Sie bitte, dass einige Email Anbieter es nicht erlauben, wenn Absender und Empfänger Email gleich gewählt werden! Als Empfänger können Sie mehrere Email Adressen über die entsprechenden Eingabefelder eingegeben werden. Es ist empfohlen auch einen Betreff und Email Text (max. 64 Zeichen) einzutragen, da leere Emails ggf. an Spam-Wächtern hängen bleiben.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      